<template>
  <div class="adv_order_transporters_multiple">
    <div v-for="transporter in getTransporters" :key="transporter.transporter_id" class="custom-control custom-radio">
      <input name="transport_id"
             v-bind:value="transporter.transporter_id"
             @input="$emit('input', $event.target.value)"
             @click="onClickTransporter($event)"
             @change="onChangeTransporter($event)"
             type="radio"
             :id="'courierRadio' + transporter.transporter_id"
             class="custom-control-input"
             :disabled="checkIfWeightExceeds(transporter.transporter_id) || transporterSmartPointsApiError(transporter)"
             v-model="selectedTransporter"
      >
      <label class="custom-control-label transporter_label" :for="'courierRadio' + transporter.transporter_id">
        {{ transporter.name }} <small><em v-html=" '(' + (transporter.transportationCost * getSelectedCurrency.rate).toFixed(2) + getSelectedCurrency.symbol + ')' "/></small>
      </label>

     <SmartPoints v-if="getSmartPointsEnableForTransporter(transporter)" :transporter="transporter" />
    </div>
  </div>
</template>

<script>
import SmartPointMixin from './SmartPoint/SmartPointMixin'
import { mapGetters, mapMutations } from 'vuex'
import { filter } from 'lodash'
import SmartPoints from './SmartPoint/SmartPoints.vue'

export default {
  name: 'AdvOrderTransportersMultiple',
  components: { SmartPoints },
  mixins: [SmartPointMixin],
  computed: {
    ...mapGetters([
      'getTransporters',
      'cartProductWeightTotal',
      'getSelectedCurrency'
    ])
  },
  data () {
    return {
      selectedTransporter: null
    }
  },
  watch: {
    selectedTransporter (val) {
      this.checkTransporterSmartPointsApiError()
    },
    getTransporters (val) {
      this.checkTransportersDataChange()
    }
  },
  mounted () {
    this.checkTransportersDataChange()
  },
  methods: {
    ...mapMutations([
      'setSelectedTransporterId'
    ]),
    async onClickTransporter (event) {
      this.setSelectedTransporterId(event.target.value)
      await this.smartPointUncheck()
      if (!this.getIsSmartPointOnlyTransporter) {
        return
      }
      this.setSmartPointIsSelected(true)
      await this.resolveDefaultMapInitialization()
    },
    checkIfWeightExceeds (transporterId) {
      if (transporterId === '13' && this.cartProductWeightTotal < 500) {
        this.$emit('set-input', '13')
        this.selectedTransporter = '13'
        return false
      }

      if (transporterId === '9' && (this.cartProductWeightTotal >= 500 && this.cartProductWeightTotal < 1400)) {
        this.$emit('set-input', '9')
        this.selectedTransporter = '9'
        return false
      }
      if (transporterId === '10' && (this.cartProductWeightTotal >= 1400 && this.cartProductWeightTotal < 2000)) {
        this.$emit('set-input', '10')
        this.selectedTransporter = '10'
        return false
      }
      if (transporterId === '11' && (this.cartProductWeightTotal >= 2000 && this.cartProductWeightTotal < 3000)) {
        this.$emit('set-input', '11')
        this.selectedTransporter = '11'
        return false
      }
      if (transporterId === '12' && this.cartProductWeightTotal >= 3000) {
        this.$emit('set-input', '12')
        this.selectedTransporter = '12'
        return false
      }
      return true
    },
    onChangeTransporter ($event) {
      this.$emit('change', $event)
      this.setSelectedSmartPoint(null)
    },
    checkTransportersDataChange () {
      if (this.getTransporters.length === 0) {
        return
      }

      if (!this.selectedTransporter) {
        this.$emit('set-input', this.getTransporters[0].transporter_id)
        this.selectedTransporter = this.getTransporters[0].transporter_id
        this.setSelectedTransporterId(this.getTransporters[0].transporter_id)
        return
      }

      const transporterExist = this.getTransporters.find(item => item.transporter_id === this.selectedTransporter)
      if (!transporterExist) {
        this.$emit('set-input', this.getTransporters[0].transporter_id)
        this.selectedTransporter = this.getTransporters[0].transporter_id
        this.setSelectedTransporterId(this.getTransporters[0].transporter_id)
      }
    },
    checkTransporterSmartPointsApiError () {
      if (this.getSelectedTransporterSmartPointsApiError && this.getSelectedTransporterObject.deliveryOptionType === '2') {
        const selectedTransporter = filter(this.getTransporters, (transporter) => {
          return !this.transporterSmartPointsApiError(transporter)
        })
        if (selectedTransporter.length === 0) {
          return
        }
        this.selectedTransporter = selectedTransporter[0].transporter_id
        this.$emit('set-input', selectedTransporter[0].transporter_id)
      }
    }
  }
}
</script>
